/**
 * Server xato konverti (dev_spec.md §4.3).
 *
 * Backend HAR BIR xatoni ikki tilda va `allowed_actions` bilan
 * qaytaradi. Interfeys shu ma'lumotni YO'QOTMASLIGI kerak:
 * "Xatolik yuz berdi" o'rniga operator nima qilishi kerakligini
 * ko'radi.
 */
export interface ApiErrorBody {
  code: string;
  message: string;
  message_ru?: string;
  entity_type?: string;
  entity_id?: string;
  details?: Record<string, unknown>;
  allowed_actions?: string[];
}

export class ApiError extends Error {
  readonly status: number;
  readonly body: ApiErrorBody;
  readonly requestId?: string;

  constructor(status: number, body: ApiErrorBody, requestId?: string) {
    super(body.message || `HTTP ${status}`);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
    this.requestId = requestId;
  }

  get code(): string {
    return this.body.code;
  }

  /** Vakolat yetmaganda interfeys tugmani yashirmaydi, SABABINI aytadi. */
  get isForbidden(): boolean {
    return this.status === 403;
  }

  get isUnauthorized(): boolean {
    return this.status === 401;
  }

  /**
   * Versiya to'qnashuvi (dev_spec.md §11.2).
   *
   * `409` bo'lsa foydalanuvchiga YANGI ma'lumot ko'rsatiladi va
   * uning qarorisiz hech narsa ustiga yozilmaydi.
   */
  get isConflict(): boolean {
    return this.status === 409 || this.body.code === "version_conflict";
  }

  get allowedActions(): string[] {
    return this.body.allowed_actions ?? [];
  }

  /** Foydalanuvchiga ko'rsatiladigan matn (tanlangan tilda). */
  text(language: "uz" | "ru"): string {
    if (language === "ru" && this.body.message_ru) return this.body.message_ru;
    return this.body.message;
  }
}

/** Tarmoq uzilishi — server javobi emas. */
export class NetworkError extends Error {
  constructor(cause: unknown) {
    super("Serverga ulanib bo'lmadi");
    this.name = "NetworkError";
    this.cause = cause;
  }
}
